const CategoryDescriptions = (props: any) => {
  if (!props.categoryCMS) return <></>
  const { title, description } = props.categoryCMS

  return (
    <div
      className={
        'mx-auto border-2 border-bidfta-blue-backdrop-dark rounded-xl p-2 text-center text-bidfta-blue-dark font-bold max-w-xl'
      }
    >
      <h2 className={'text-xl'}>{title}</h2>
      <p>{description}</p>
    </div>
  )
}

export default CategoryDescriptions
